import { render, staticRenderFns } from "./D21.vue?vue&type=template&id=198056de&scoped=true"
import script from "./D21.vue?vue&type=script&lang=js"
export * from "./D21.vue?vue&type=script&lang=js"
import style0 from "./D21.vue?vue&type=style&index=0&id=198056de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198056de",
  null
  
)

export default component.exports